import React, { useState } from "react";
import Header from "../components/Header";
import DashboardPulse from "../components/Dashboard/DashboardPulse";
import FinancialDashboard from "../components/Dashboard/FinancialDashboard";
import { useDashboardStats } from "../hooks/useDashboardStats";
import "../components/Dashboard/dashboardZones.css";
import "./Home.css";

const Home = () => {
  const { stats, lastUpdated, refresh, loading, error } = useDashboardStats();
  const [dashboardView, setDashboardView] = useState("financial");

  if (loading) return <p className="loading">Cargando dashboard...</p>;
  if (error) return <p className="error">Error: {error}</p>;
  if (!stats) return null;

  return (
    <div className="dashboard-home">
      <Header />
      <div className="dashboard-content">
        <div className="main-content-section">
          <div className="dashboard-view-switch" aria-label="Selector de dashboard">
            <button
              type="button"
              className={dashboardView === "financial" ? "active" : ""}
              onClick={() => setDashboardView("financial")}
            >
              Financiero
            </button>
            <button
              type="button"
              className={dashboardView === "operations" ? "active" : ""}
              onClick={() => setDashboardView("operations")}
            >
              Command Center
            </button>
          </div>

          {dashboardView === "financial" ? (
            <FinancialDashboard
              stats={stats}
              lastUpdated={lastUpdated}
              loading={loading}
              onRefresh={refresh}
            />
          ) : (
            <DashboardPulse
              stats={stats}
              lastUpdated={lastUpdated}
              loading={loading}
              onRefresh={refresh}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
